import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class ConceptService {
  public url: string;
  
  constructor(
    public _http: HttpClient
  ) {
    this.url = environment.conceptos+"api/v1/concept/";   
  }

  
  findAllConc(): Observable<any> {
    let ruta = `${this.url}findAll`;
    return this._http.get(ruta);
  }
  findConcById(cadena : string): Observable<any> {
    let ruta = `${this.url}findBy?${cadena}`;
    return this._http.get(ruta);
  }
  deleteConcById(cadena : string): Observable<any> {
    return this._http.delete(`${this.url}deleteConcept?${cadena}`);
  }
  saveConc(form : any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(`${this.url}save`, params, { headers: headersResp });
  }
  updateConc(form : any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.put(`${this.url}updateConcept`, params, { headers: headersResp });
  }

}